import { IconPropsType } from '..';

export const CasinoFeatures3 = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=security, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=default, currency=default">
      <path
        id="Vector"
        d="M10.0305 1.00006L2.66675 4.27246V9.18106C2.66675 13.7225 5.80955 17.9687 10.0305 19.0001C14.2515 17.9687 17.3943 13.7225 17.3943 9.18106V4.27246L10.0305 1.00006ZM10.0305 10.0001H15.7581C15.3243 13.3625 13.0743 16.3649 10.0305 17.3063V10.0001H4.30295V5.33626L10.0305 2.80006V10.0001Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
